import axios from 'axios';
import i18n from '../i18n';
// Token/email in the request identify the account. An unrelated signed-in session is irrelevant.
// In particular a rejected action must never refresh or log out that session.
export const accountActionApi = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: { 'Content-Type': 'application/json', 'Accept-Language': i18n.language || 'en' }
});
